import React, { useContext } from "react";
import DetailLayout from "../components/DetailLayout";
import DetailLayoutHeader from "../components/DetailLayout/components/DetailLayoutHeader";
import { CourseContext } from "../Store";
import styles from "./index.module.scss";
import { Col, Icon, Row, Spin, Tooltip } from "antd";
import { Link, useHistory } from "react-router-dom";
import useDeviceType from "../../../Utils/useDeviceType";
import useRequest from "../../../Utils/useRequest";
import { getReportData } from "./services";
import useBatchPicker from "../../main/utils/useBatchPicker";
import ReportCard from "./Components/ReportCard";
import DetailHrefButtonRow from "../../../components/DetailHrefButtonRow";

const Index = () => {
    const { course } = useContext(CourseContext);
    const history = useHistory();
    const { isPC } = useDeviceType();
    const { batch } = useBatchPicker();

    const [data, { loading }, reload] = useRequest(
        () =>
            getReportData({
                batchNo: batch,
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                customerCode: "kb_dconline"
            }),
        {},
        []
    );

    return (
        <DetailLayout
            breadcrumb="学习报告"
            title="学习报告"
            mobileHeaderExtra={
                <Link className={styles.mRoot} to="/">
                    <Icon type="file-text" style={{ fontSize: 22 }} />
                </Link>
            }>
            {isPC && (
                <DetailLayoutHeader
                    title={course.courseName}
                    extra={
                        <DetailHrefButtonRow>
                            <></>
                            <Link
                                to={`/course/score/detail/${course.courseNo}/${course.courseSeq}/${course.weekTimeId}?courseName=${course.courseName}`}
                                className={styles.href}>
                                <Icon
                                    type="file-text"
                                    style={{ fontSize: 22 }}
                                />
                                <p>成绩单</p>
                            </Link>
                        </DetailHrefButtonRow>
                    }
                />
            )}
            <Spin spinning={loading}>
                <div className={styles.main}>
                    <h3 className={styles.title}>
                        教学活动参与概况&nbsp;&nbsp;
                        <Tooltip title="说明：平均得分为多次活动的成绩折算成百分制后所获取的平均数。">
                            <Icon type="question-circle" />
                        </Tooltip>
                    </h3>
                    <Row gutter={30} type="flex">
                        {data?.Join.map(item => (
                            <Col
                                sm={8}
                                key={item.title}
                                xs={24}
                                style={{ marginBottom: 30 }}>
                                <ReportCard {...item} />
                            </Col>
                        ))}
                    </Row>
                    <h3 className={styles.title}>课件资源学习概况</h3>
                    <Row gutter={30}>
                        {data?.CoursewareLearning.map(item => (
                            <Col
                                sm={8}
                                key={item.title}
                                xs={24}
                                style={{ marginBottom: 30 }}>
                                <ReportCard {...item} />
                            </Col>
                        ))}
                    </Row>
                </div>
            </Spin>
        </DetailLayout>
    );
};

export default Index;
